import app_img from '@/public/article/App.webp';
import article1 from '@/public/article/picture.webp';
import schedule_img from '@/public/article/Schedule_1.webp';
import invoicing from '@/public/industries/painting/Proactive Notifications.webp';
import route_img from '@/public/industries/window_cleaning/Accurate Time Tracking.webp';
import managment_img from '@/public/industries/window_cleaning/Comprehensive Customer Management.webp';
import main_bg from '@/public/industries/window_cleaning/main.webp';
import review1 from '@/public/reviews/CapterraSvg.svg';
import review2 from '@/public/reviews/GetAppSvg.svg';
import review3 from '@/public/reviews/SoftwareAdvice.svg';
import { ArticleType } from '@/types/articles';
import { IRoutePath } from '@/types/router';

const faq = [
  {
    title: 'Does My Window Cleaning Business Need Software?',
    text: 'Efficiency is boosted with the help of specialized software that streamlines all the scheduling, customer management, and invoicing processes. This reduces the administrative load and increases customer satisfaction, so this is the tool without which no window cleaning business can afford to be if they are to grow and be efficient.',
  },
  {
    title: 'Does Orcatec Have a Window Cleaning Management App?',
    text: `Yes, Orcatec provides a one-size-fits-all management app solely dedicated to window cleaning businesses. The app can support all business functions, from dispatching to customer relations and invoicing, to list just a few, using any device. It's just perfect in managing your business from the office or in the field.`,
  },
  {
    title: 'Is Orcatec Window Cleaning Software Free?',
    text: 'Orcatec provides free window cleaning software. It is perfect for new or small businesses, without additional premium features, even when your business grows.',
  },
  {
    title: 'What makes Orcatec the Best Window Cleaning Software?',
    text: 'Orcatec is considered the best window cleaning management software due to its comprehensive set of features tailored to the specific needs of the industry. It offers exceptional customization, ease of use, and robust functionality that encompasses scheduling, customer management, and financial transactions, all within a single platform.',
  },
];

const testimonals = [
  {
    text: `The scheduling feature alone has cut our administrative time in half. We've been able to take on more jobs without adding extra stress. Plus, the app for window cleaners lets our team stay updated in real-time. I highly recommend it for any growing window cleaning business!`,
    name: 'Emily T.,',
    position: 'ClearView Solutions',
  },

  {
    text: `Mostly, it was the free starter package that drew me to Orcatec, but so much more has been realized. The software is easily customizable, which is to our advantage when we try to get the best software we need. Scaling with our business has been extremely easy.`,
    name: 'Carlos G.,',
    position: 'Bright Pane Professionals',
  },
  {
    text: `Orcatec has truly transformed how we manage our window cleaning operations. The flexibility in choosing paid features means we only pay for what we need. The system’s availability across different devices is a huge plus for our techs in the field. It's an all-in-one solution that fits perfectly with our business model.`,
    name: 'John M.,',
    position: ' Sparkle Clean Windows',
  },
  {
    text: `The scheduling feature alone has cut our administrative time in half. We've been able to take on more jobs without adding extra stress. Plus, the app for window cleaners lets our team stay updated in real-time. I highly recommend it for any growing window cleaning business!`,
    name: 'Emily T.,',
    position: 'ClearView Solutions',
  },

  {
    text: `Mostly, it was the free starter package that drew me to Orcatec, but so much more has been realized. The software is easily customizable, which is to our advantage when we try to get the best software we need. Scaling with our business has been extremely easy.`,
    name: 'Carlos G.,',
    position: 'Bright Pane Professionals',
  },
  {
    text: `Orcatec has truly transformed how we manage our window cleaning operations. The flexibility in choosing paid features means we only pay for what we need. The system’s availability across different devices is a huge plus for our techs in the field. It's an all-in-one solution that fits perfectly with our business model.`,
    name: 'John M.,',
    position: ' Sparkle Clean Windows',
  },
];

const industries = {
  title: 'Our Top Industries',
  description: `Orcatec software has been professionally touched with a view to serving the most diversified needs and challenges of the industry. From small-scale to large, our software is very much flexible in operating ways and can be reshaped to suit the workings of a sector. 
  `,
  items: [
    { title: 'HVAC', path: IRoutePath.INDUSTRIES_HVAC },
    { title: 'Plumbing', path: IRoutePath.INDUSTRIES_PLUMBING },
    { title: 'Appliance Repair', path: IRoutePath.INDUSTRIES_APPLIANCE },
    { title: 'Electrician', path: IRoutePath.INDUSTRIES_ELECTRICIAN },
    { title: 'Garage Door', path: IRoutePath.INDUSTRIES_GARAGE_DOOR },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Property Maintenance',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Junk Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Home Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Handyman',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Landscaping and Lawn',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Construction',
      path: IRoutePath.INDUSTRIES,
    },

    {
      title: 'Home Renovation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Automotive',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pest Control',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Custom Home Building',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Window Cleaning',
      path: IRoutePath.INDUSTRIES,
    },

    {
      title: 'Carpet Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pool and Spa Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Locksmith',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fireplace and Chimney',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Roofing',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Water Treatment',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Alarm and Security',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Irrigation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Painting Contractors',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Fire Safety',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Computer Service',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Moving',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Snow Removal',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Air Duct Cleaning',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Remodeling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Janitorial Services',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Excavation',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Demolition Contractor',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tree Care',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Restoration',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Flooring',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Tiling',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Drywall',
      path: IRoutePath.INDUSTRIES,
    },
    {
      title: 'Pressure Washing',
      path: IRoutePath.INDUSTRIES,
    },
  ],
};

const articles = {
  title: `Software Features Made for Window Cleaning Businesses`,
  items: [
    {
      type: ArticleType.VERICAL,
      image: {
        path: schedule_img,
        alt: 'Scheduling appointment',
      },
      href: '#',
      tag: 'Efficient Dispatching & Scheduling',
      title: 'Advanced Job Scheduling',
      text: `We have new and improved dispatching and scheduling tools that will let you smoothly schedule jobs and automatically dispatch them to suitable technicians. The feature can ensure optimal course planning and time management.`,
      list: [
        {
          text: 'Organize both routine and one-time cleaning appointments.',
        },
        {
          text: 'Automatically assign jobs to available and suitable technicians. ',
        },
        {
          text: 'Utilize dynamic dispatch features to adjust schedules on the fly.',
        },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: managment_img,
        alt: 'Customer Relationships Management',
      },
      href: '#',
      tag: 'Customer Relationships Management',
      title: 'Comprehensive Customer Management',
      text: `Maintain detailed records of all customer interactions, including job history and specific notes. This feature enhances relationship management and service personalization.`,
      list: [
        {
          text: 'Track and manage detailed customer profiles and previous work history.',
        },
        {
          text: 'Record and access notes on customer preferences or specific requirements.',
        },
        {
          text: 'Easily retrieve and view customer interaction history to provide tailored services.',
        },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: invoicing,
        alt: 'Invoicing and Billing ',
      },
      href: '#',
      tag: 'Notifications',
      title: 'Proactive Notifications',
      text: `Automated reminder and notification systems keep your customers informed and engaged. The feature facilitates no-shows and improves the client experience.`,

      list: [
        {
          text: 'Dispatch automated emails or text messages to remind clients about forthcoming services.',
        },
        {
          text: 'Customize notification timings and messages according to customer preferences.',
        },
        {
          text: 'Enhance communication efficiency, ensuring customers are well informed and prepared for appointments.',
        },
      ],
    },

    {
      type: ArticleType.VERICAL,
      image: {
        path: route_img,
        alt: 'Workflow dispatching',
      },
      href: '#',
      tag: 'Workflow dispatching',
      title: 'Accurate Time Tracking',
      text: `Function Description: Monitor and manage how employees utilize their working hours with precise time tracking. This feature is crucial for payroll accuracy and operational efficiency.`,
      list: [
        {
          text: 'Track the duration each employee spends on a specific job.',
        },
        {
          text: 'Analyze time data to optimize workflows and improve productivity.',
        },
        {
          text: 'Integrate time tracking with payroll systems to streamline compensation processes.',
        },
      ],
    },
  ],
};

const intro = {
  imageSrc: main_bg,
  tag: 'Window Cleaning Software',
  title: {
    first_part: 'Make Your Window Cleaning Business ',
    second_part: 'More Streamline',
  },
  description: `Discover the ultimate solution to managing your window cleaning business effectively: free software. Improve productivity by automating routine work, eliminating paper, and providing exemplary services to your customers. You'll spend less time on administration and free up more time for growing your business using our intuitive window cleaning app.`,
  info: [
    { title: '40%', description: 'Time Savings on Administrative Tasks' },
    { title: '50%', description: 'Decrease Paperwork Errors' },
  ],
};

const fullArticle1 = {
  image: {
    path: article1,
    alt: 'What is Window Cleaning Business Software?',
  },
  title: 'What is Window Cleaning Business Software?',
  description: `Window cleaning business software is a specialty software made for such business operators to operate their services properly. This cloud-based software can be accessed effortlessly from any device via link and provides real-time updates to business proprietors and their workers.`,
  item: [
    {
      title: 'Scheduling and Dispatching',
      description: ` Orcatec's software includes a dynamic scheduling interface that simplifies the process of booking and adjusting appointments. This system helps reduce scheduling conflicts and optimizes routes for technicians, saving time and fuel costs.
      `,
    },
    {
      title: 'Customer Management',
      description: `The software comes with tools for tracking customer information, job history, and feedback, which enables businesses to personalize their services and optimize customer satisfaction.
        `,
    },
    {
      title: 'Billing and Invoicing',
      description:
        'Orcatec automatically invoices what needs to be paid for, hence quick payment, which is key to reducing administrative overhead. The platform allows the use of a multiple currency payment system, hence convenient to the business and its customers.',
    },
  ],
};

const fullArticle2 = {
  image: {
    path: app_img,
    alt: 'Why Window Cleaning Contractors Choose Orcatec?',
  },
  title: 'Why Window Cleaning Contractors Choose Orcatec?',
  description: `Window cleaning contractors are increasingly choosing Orcatec for several compelling reasons that cater specifically to their needs. `,
  item: [
    {
      title: '',
      description:
        'Orcatec offers a no-cost entry-level option, making it accessible for new or small-scale window-cleaning businesses to start using the software without any initial investment. ',
    },
    {
      title: '',
      description:
        'Users value being able to personalize the type of subscription only with the features that they deem useful.',
    },
    {
      title: '',
      description: `The window cleaning service software is made with high flexibility and can be tailored in accordance with peculiar operational situations. Orcatec is developed with the same performance on any number of devices and formats, either PCs, tablets, or smartphones. This software is designed in a way that it can support software with both iOS and Android operating systems, so it enhances the usability factor greatly.`,
    },
  ],
};

const reviews = {
  title: 'Our Reviews',
  items: [
    { path: review1.src, width: review1.width, alt: 'Capterra' },
    { path: review2.src, width: review2.width, alt: 'GetApp' },
    { path: review3.src, width: review3.width, alt: 'Software Advice' },
  ],
};

const blog = {
  title: 'Our Blog',
  description: `Find the latest insights and updates on how to make your window cleaning business a shining success on our blog. We delve deep into the hottest trends, share tips and tricks, and offer expert advice for window cleaning professionals. 
  `,
};

const bookDemo = {
  title: 'Book a Free Demo',
  description: `Let us guide you to experience in appliance repair management software! Orcatec team is here to help you. Our experts are ready to amplify your operational efficiency.`,
};

export {
  reviews,
  fullArticle2,
  fullArticle1,
  intro,
  articles,
  industries,
  testimonals,
  faq,
  blog,
  bookDemo,
};
